import React from "react";
import Flagship from "../../core/flagship";
import { Link } from "react-router";
import { Button, Table, Loader, Icon } from "semantic-ui-react";

class RecentFavorites extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
  }

  // Separate component state for UI only
  getInitialState() {
    return {
      offset: 0,
      items: [],
      error: "",
      loading: false
    };
  }

  componentDidMount() {
    if (this.props.userId !== 0) {
      this.getFeedItems(this.props.userId);
    }
  }

  componentWillUnmount() {
    this.interval = null;
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.instance !== this.props.instance && nextProps.userId !== 0) {
      this.getFeedItems(nextProps.userId);
    }
  }

  getFeedItems(userId) {
    this.setState({
      loading: true
    });

    let self = this;

    if (typeof userId === "undefined") {
      userId = this.props.userId;
    }

    Flagship.get(
      "search/any/",
      {
        search: "",
        onlyFavorites: userId,
        combine: false,
        limit: 20
      },
      function(response) {
        if (response.data.success === true) {
          self.setState({
            items: response.data.results,
            loading: false
          });
        } else {
          self.setState({
            error: "Failed to load recent activity.",
            loading: false
          });
        }
      }
    );
  }

  getMessage(action) {
    if (Flagship.config.possibleActions.hasOwnProperty(action)) {
      return Flagship.config.possibleActions[action];
    }
    return "";
  }

  getRecordLink(name, key, type) {
    let icon = "exclamation";
    switch (type) {
      case "client":
        icon = "briefcase";
        break;
      case "rfp":
        icon = "dollar";
        break;
      case "io":
        icon = "rocket";
        break;
      case "line_item":
        icon = "pin";
        break;
      case "io_product":
        icon = "pin";
        break;
    }

    return (
      <h5>
        <Icon
          className="table-icon"
          disabled
          size="large"
          color="grey"
          name={icon}
        />
        {name}
      </h5>
    );
  }

  render() {
    let getRecordLink = this.getRecordLink;
    return (
      <div className="fade-in">
        {typeof this.state.items !== "undefined" &&
        this.state.items.length > 0 ? (
          <Table>
            <Table.Body>
              {this.state.items.map(function(item, i) {
                return (
                  <Table.Row
                    className="dashboard-table-row"
                    key={"feed-item-" + i}
                  >
                    <Table.Cell>
                      <Link
                        className="single-dash-widget-record"
                        to={"/" + item.record_type + "/view/" + item.record_key}
                      >
                        {getRecordLink(
                          item.record_name,
                          item.record_key,
                          item.record_type
                        )}
                      </Link>
                    </Table.Cell>
                    <Table.Cell textAlign="right">
                      <Link
                        className="single-dash-widget-record"
                        to={"/" + item.record_type + "/view/" + item.record_key}
                      >
                        <em>
                          In your favorites{" "}
                          <Icon name="star" className="favorite" />
                        </em>
                      </Link>
                    </Table.Cell>
                  </Table.Row>
                );
              })}
            </Table.Body>
          </Table>
        ) : (
          <div>
            <span className="white-text">
              No favorites found. Go add some and come back!
            </span>
          </div>
        )}
        <Link to="/user/favorites">
          <Button
            className="view-all-button"
            icon="caret right"
            content="View all favorites"
          />
        </Link>
        <span>&nbsp;</span>&nbsp;
        {this.state.loading === true ? (
          <Loader
            className="flagship-loader"
            active={this.state.loading}
            inline
          />
        ) : null}
      </div>
    );
  }
}
export default RecentFavorites;



// WEBPACK FOOTER //
// ./src/components/dashboard/RecentFavorites.js